/* eslint-disable */
import axios from "axios";

// Load permissions from localStorage on initialization
const storedPermissions = localStorage.getItem("permissions");
const initialPermissions = storedPermissions ? JSON.parse(storedPermissions) : [];

export default {
  namespaced: true,
  state: {
    token: "",
    user: {},
    company: {},
    roleName: "",
    positionName: "",
    permissions: initialPermissions, // Initialize from localStorage
  },
  getters: {
    authenticated(state) {
      return state.token ? true : false;
    },
    user(state) {
      return state.user;
    },
    company(state) {
      return state.company;
    },
    roleName(state) {
      console.log("roles", state.user);

      return state.user.roles[0].name;
    },
    positionName(state) {
      console.log("position", state.user);

      return state.user.position && state.user.position.name;
    },
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data;
    },
    SET_USER(state, data) {
      state.user = data;
      console.log("state User", state.user);

      let userCompanies = data ? data.companies : "";
      state.company = userCompanies.length ? userCompanies[0] : {};
    },
    SET_COMPANY(state, company) {
      state.company = company;
      localStorage.setItem("company", JSON.stringify(company)); // This is when the Super Admin Selects a Company from the dropdown
      if (company != null && company.id) {
        axios.defaults.headers.common["company-id"] = company.id;
      } else axios.defaults.headers.common["company-id"] = null;
    },
    SET_PERMISSIONS(state, data) {
      // Store permissions array (MODULE.PERMISSION format)
      state.permissions = data || [];
      // Persist permissions to localStorage
      localStorage.setItem("permissions", JSON.stringify(data || []));
    },
  },
  actions: {
    async logIn({ dispatch }, credentails) {
      const response = await axios.post("/login", credentails);
      await dispatch("attempt", response.data.token);
      // Store permissions from login response
      if (response.data.permissions) {
        dispatch("setPermissions", response.data.permissions);
      }
    },
    async attempt({ state, commit }, token) {
      if (token) {
        commit("SET_TOKEN", token); // subscriber.js automatically sets Authorization header
      }

      if (!state.token) return;

      try {
        const response = await axios.get("/me");
        commit("SET_USER", response.data.data);
        console.log('permissions', response.data.permissions);
        // Store permissions from /me response
        commit("SET_PERMISSIONS", response.data.permissions || []);
        var company = JSON.parse(localStorage.getItem("company"));
        if (company) commit("SET_COMPANY", company);
      } catch (e) {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
        commit("SET_COMPANY", null);
        commit("SET_PERMISSIONS", []);
      }
    },
    logOut({ commit }) {
      // Simple logout - just clear state (like OggyKart)
      // Backend token cleanup happens via middleware expiration
      commit("SET_TOKEN", null); // subscriber.js automatically clears token from localStorage and Authorization header
      commit("SET_USER", null);
      commit("SET_COMPANY", null);
      commit("SET_PERMISSIONS", []); // This clears permissions from state

      // Clear remaining localStorage items
      localStorage.removeItem("permissions");
      localStorage.removeItem("company");
      localStorage.removeItem("company-id");
    },
    setCompany({ commit }, company) {
      commit("SET_COMPANY", company);
    },
    setPermissions({ commit }, permissions) {
      commit("SET_PERMISSIONS", permissions);
    },
  },
};
